import { action } from 'typesafe-actions';
import ActionTypes from './constants';

export const getTicketTypesList = () => action(ActionTypes.GET_TICKET_TYPES_LIST);
export const customerSupportListSuccess = (payload: any) => action(ActionTypes.CUSTOMER_SUPPORT_LIST_SUCCESS, payload);
export const fetchTicketTypesById = (id: string) => action(ActionTypes.FETCH_TICKET_TYPES_BY_ID, id);
export const editSaveCustomerSupport = (payload: any) => action(ActionTypes.EDIT_SAVE_CUSTOMER_SUPPORT, payload);
export const setCustomerSupportLoader = (payload: boolean) => action(ActionTypes.SET_CUSTOMER_SUPPORT_LOADER, payload);
export const setSortBy = (payload: string) => action(ActionTypes.SET_SORT_BY, payload);
export const setCustomerSupportDetail = (payload: any) => action(ActionTypes.SET_CUSTOMER_SUPPORT_DETAIL, payload);
